var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignInBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 720,
    viewBox: "0 0 1440 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -563,
    width: 2566,
    height: 720,
    fill: "url(#paint0_linear_173_89956)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M747.971 249C1150.7 249 1581.1 475.366 1784 527.019L1784 722.999L-534 723L-534 659.193C-134.345 656.914 345.241 249 747.971 249Z",
    fill: "url(#paint1_linear_173_89956)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1659.94 117.101C1523.47 105.426 1190.78 31.4077 962.849 209.815C742.178 382.538 61.0325 805.936 -554.458 819.658L-615 819.658C-594.903 820.118 -574.716 820.11 -554.458 819.658L1671 819.658L1659.94 117.101Z",
    fill: "url(#paint2_linear_173_89956)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_173_89956",
    x1: 246.499,
    y1: -33.8462,
    x2: 233.481,
    y2: 465.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEEDE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#B1EAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51C4BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_173_89956",
    x1: 1738.74,
    y1: 665.686,
    x2: -511.635,
    y2: 665.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932292,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_173_89956",
    x1: 1484.39,
    y1: 295.343,
    x2: 1649.93,
    y2: 295.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignInBackground);
export default __webpack_public_path__ + "static/media/sign_in_background.a6b7f2c85d98a61435574dadd009da99.svg";
export { ForwardRef as ReactComponent };